export const LOCALES = {
	ENGLISH: 'EN',
	SPANISH: 'ES',
	PORTUGUESE: 'PT-BR',
}
